<div class="popup-dialog">
    <div
        class="trezo-card w-100 border-radius d-block bg-white border-0 shadow-none"
    >
        <div
            class="trezo-card-header d-flex align-items-center justify-content-between"
        >
            <div class="trezo-card-title">
                <h5 class="mb-0">Pdf to Image Extract</h5>
            </div>
            <div class="trezo-card-subtitle">
                <button
                    (click)="toggleClass()"
                    class="p-0 border-0 lh-1 bg-transparent transition"
                >
                    <i class="ri-close-fill"></i>
                </button>
            </div>
        </div>
        <div class="trezo-card-content v-scroll">
            <div class="row">
                <div class="col-md-12">
                    <div class="pdf-cropper-container">
                        <!-- <h1>PDF Cropper Tool</h1> -->

                        <!-- File Upload -->
                        <div class="upload-section" *ngIf="!pdfDocument()">
                            <label for="file-input" class="upload-button">
                                📄 Choose PDF File
                            </label>
                            <p class="upload-help">
                                Select a PDF file to start cropping
                            </p>
                        </div>
                        <!-- Hidden File Input -->
                        <input
                            type="file"
                            #fileInput
                            accept=".pdf"
                            (change)="onFileSelected($event)"
                            class="file-input-hidden"
                            id="file-input"
                        />

                        <!-- File Upload -->
                        <!-- <div class="upload-section" *ngIf="!pdfDocument()">
    <input
      type="file"
      #fileInput
      accept=".pdf"
      (change)="onFileSelected($event)"
      class="file-input"
      id="file-input"
    />
    <label for="file-input" class="upload-button"> 📄 Choose PDF File </label>
    <p class="upload-help">Select a PDF file to start cropping</p>
  </div> -->

                        <!-- PDF Viewer with Tools -->
                        <div class="viewer-container" *ngIf="pdfDocument()">
                            <!-- Toolbar -->
                            <div class="toolbar">
                                <div class="tool-group">
                                    <button
                                        (click)="zoomIn()"
                                        class="tool-btn zoom-btn"
                                    >
                                        🔍+ Zoom In
                                    </button>
                                    <button
                                        (click)="zoomOut()"
                                        class="tool-btn zoom-btn"
                                    >
                                        🔍- Zoom Out
                                    </button>
                                    <button
                                        (click)="resetZoom()"
                                        class="tool-btn reset-btn"
                                    >
                                        🔄 Reset
                                    </button>
                                    <span class="zoom-level"
                                        >{{
                                            Math.round(zoomLevel() * 100)
                                        }}%</span
                                    >
                                    <button
                                        (click)="toggleFullScreen()"
                                        class="tool-btn fullscreen-btn"
                                    >
                                        ⛶ Full Screen
                                    </button>
                                </div>

                                <div class="tool-group page-controls">
                                    <button
                                        (click)="previousPage()"
                                        [disabled]="currentPage() <= 1"
                                        class="tool-btn nav-btn"
                                    >
                                        ← Previous
                                    </button>
                                    <span class="page-info"
                                        >Page {{ currentPage() }} of
                                        {{ totalPages() }}</span
                                    >
                                    <button
                                        (click)="nextPage()"
                                        [disabled]="
                                            currentPage() >= totalPages()
                                        "
                                        class="tool-btn nav-btn"
                                    >
                                        Next →
                                    </button>
                                </div>

                                <div class="tool-group">
                                    <button
                                        (click)="toggleCropMode()"
                                        class="tool-btn crop-btn"
                                        [class.active]="cropMode()"
                                    >
                                        ✂️
                                        {{
                                            cropMode()
                                                ? "Exit Crop"
                                                : "Crop Mode"
                                        }}
                                    </button>

                                    <button
                                        (click)="exportCrop()"
                                        class="tool-btn export-btn"
                                        [disabled]="!cropArea()"
                                        *ngIf="cropArea()"
                                    >
                                        👁️ Preview
                                    </button>
                                </div>

                                <button
                                    (click)="loadNewPDF()"
                                    class="tool-btn new-pdf-btn"
                                >
                                    📁 Load New PDF
                                </button>

                                <!-- <button
                                    (click)="toggleClass()"
                                    class="tool-btn close-btn"
                                >
                                    ✖️ Close
                                </button> -->
                            </div>

                            <!-- Canvas Container -->
                            <div class="canvas-scrollable">
                                <div class="canvas-container" #canvasContainer>
                                    <div class="canvas-wrapper">
                                        <canvas
                                            #pdfCanvas
                                            (mousedown)="onMouseDown($event)"
                                            (mousemove)="onMouseMove($event)"
                                            (mouseup)="onMouseUp()"
                                            (mouseleave)="onMouseUp()"
                                            (dblclick)="onDoubleClick($event)"
                                            (dragstart)="
                                                $event.preventDefault()
                                            "
                                            (selectstart)="
                                                $event.preventDefault()
                                            "
                                            (wheel)="onWheel($event)"
                                            [style.cursor]="getCursor()"
                                            [style.user-select]="'yes'"
                                            [style.touch-action]="'yes'"
                                            class="pdf-canvas"
                                        >
                                        </canvas>

                                        <!-- Enhanced Crop Selection Overlay -->

                                        <div
                                            class="crop-overlay"
                                            *ngIf="
                                                cropArea() &&
                                                cropMode() &&
                                                getCropWidth() > 0 &&
                                                getCropHeight() > 0
                                            "
                                            [style.left.px]="
                                                getCropLeft() * zoomLevel()
                                            "
                                            [style.top.px]="
                                                getCropTop() * zoomLevel()
                                            "
                                            [style.width.px]="
                                                getCropWidth() * zoomLevel()
                                            "
                                            [style.height.px]="
                                                getCropHeight() * zoomLevel()
                                            "
                                        >
                                            <div class="crop-info">
                                                {{ Math.round(getCropWidth()) }}
                                                ×
                                                {{
                                                    Math.round(getCropHeight())
                                                }}px
                                            </div>
                                        </div>

                                        <!-- <div
          class="crop-overlay"
          *ngIf="
            cropArea() &&
            cropMode() &&
            getCropWidth() > 0 &&
            getCropHeight() > 0
          "
          [style.left.px]="getCropLeft()"
          [style.top.px]="getCropTop()"
          [style.width.px]="getCropWidth()"
          [style.height.px]="getCropHeight()"
        >
          <div class="crop-info">
            {{ Math.round(getCropWidth() / zoomLevel()) }} ×
            {{ Math.round(getCropHeight() / zoomLevel()) }}px
          </div>
          <div class="crop-handles">
            <div class="handle top-left"></div>
            <div class="handle top-right"></div>
            <div class="handle bottom-left"></div>
            <div class="handle bottom-right"></div>
          </div>
        </div> -->
                                    </div>
                                </div>
                            </div>

                            <!-- Enhanced Status Bar -->
                            <div class="status-bar">
                                <span class="status-item">
                                    🎯
                                    {{
                                        cropMode()
                                            ? "Crop Mode: Click and drag to select area • Double-click to zoom"
                                            : "Pan Mode: Drag to move • Scroll/Double-click to zoom"
                                    }}
                                </span>
                                <span class="status-item" *ngIf="cropArea()">
                                    Selected:
                                    {{
                                        Math.round(
                                            getCropWidth() / zoomLevel()
                                        )
                                    }}×{{
                                        Math.round(
                                            getCropHeight() / zoomLevel()
                                        )
                                    }}px ({{ Math.round(getCropWidth()) }}×{{
                                        Math.round(getCropHeight())
                                    }}px at
                                    {{ Math.round(zoomLevel() * 100) }}%)
                                </span>
                            </div>

                            <!-- Loading Indicator -->
                            <div class="loading" *ngIf="isLoading()">
                                <div class="spinner"></div>
                                <p>Loading PDF...</p>
                            </div>
                        </div>

                        <!-- Image Preview Modal -->
                        <div class="preview-modal" *ngIf="showPreview()">
                            <div class="preview-modal-content">
                                <div class="preview-header">
                                    <h5 class="mb-0">Preview & Rotate Image</h5>
                                </div>

                                <div class="preview-body">
                                    <div class="preview-image-container">
                                        <img
                                            [src]="previewImageData()"
                                            [style.transform]="'rotate(' + rotationAngle() + 'deg)'"
                                            class="preview-image"
                                            alt="Cropped preview"
                                        />
                                    </div>
                                </div>

                                <div class="preview-footer">
                                    <button
                                        (click)="rotateImage()"
                                        class="preview-btn rotate-btn"
                                        title="Rotate 90° clockwise"
                                    >
                                        🔄 Rotate
                                    </button>

                                    <button
                                        (click)="reCapture()"
                                        class="preview-btn recapture-btn"
                                        title="Re-capture area"
                                    >
                                        ✂️ Re-capture
                                    </button>

                                    <button
                                        (click)="finalizeImage(false)"
                                        class="preview-btn select-btn"
                                        title="Select for upload"
                                    >
                                        💾 Select
                                    </button>

                                    <button
                                        (click)="finalizeImage(true)"
                                        class="preview-btn download-btn"
                                        title="Download image"
                                    >
                                        ⬇ Download
                                    </button>

                                    <button
                                        (click)="closePreview()"
                                        class="preview-btn close-preview-btn"
                                        title="Close preview"
                                    >
                                        ✖️ Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
